<template>
<div class="experience container" id="experience">
    <div class="row">
        <div class="col col-lg-6 col-md-6 col-sm-12 experience-text">
            <h3 data-aos="fade-left" data-aos-duration="800"
            data-aos-anchor-placement="top-center" data-aos-delay="100">My Experience</h3>
            <hr data-aos="fade-left" data-aos-duration="800"
            data-aos-anchor-placement="center-center" data-aos-delay="150">
            <p data-aos="fade-left" data-aos-duration="800"
            data-aos-anchor-placement="center-center" data-aos-delay="200"> 
            I have several work experience such as Software Engineer intern at Lenna.ai, Web Developer at Pateron Indonesia, and currently as Full Stack Developer at PT. Samanasoft Inovasi Persada.
            At Lenna.ai as Software Engineer my responsibility is a lot in fixing issues such as mobile responsive, API integretion, Authentication From Laravel to Vue.js and work with UI/UX team to create a User Friendly UI. 
            When i was at Pateron i once having a difficult task where i have to implementing Pomodoro technique at Frontend. After looking a lot of references and a lot of experiment by code i finally done it and the feature work charmly. 
            And currently at PT. Samanasoft Inovasi Persada i got a project to create a Full Stack Blogger Website for Physician. I Create a Frontend with Nuxt and Backend With .Net and Laravel.
            </p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center">
            <img data-aos="fade" data-aos-duration="1000"
            data-aos-anchor-placement="top-center" class="img-content" src="../../public/images/exp-hero.png" alt="">
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Experience'
}
</script>

<style lang="scss" scoped>
.experience {
    width: 100%;
    padding: 0px 50px;
    .row {
        .img-content {
            transform: scale(0.65) !important;
        }
        .img-card {
            margin-bottom: 10px;
        }
        .card {
            border: 0;
            background: transparent;
        }
        .experience-text {
            padding: 20% 0%;
        }
        ul li {
            list-style: #5f0597;
        }
        @media (max-width: 767.8px) {
            .img-content {
                display: none;
            }
            .img-card {
                height: 100px;
                margin-bottom: 10px;
            }
        }
    }
}
</style>
